// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2J10k","signatureButtonsRight":"ModalSign_signatureButtonsRight__3A24k"};